"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setRaygunUser = void 0;
var getRaygunInstance_1 = require("./getRaygunInstance");
/**
 * Sets the user information so that it's included in the error log messages.
 * @param userDetails the logged in user info
 */
function setRaygunUser(userDetails) {
    if (!userDetails || !userDetails.identifier) {
        return;
    }
    var rg4js = (0, getRaygunInstance_1.getRaygunInstance)();
    // https://raygun.com/documentation/language-guides/javascript/vuejs/#step-5-add-user-tracking-optional
    rg4js("setUser", userDetails);
}
exports.setRaygunUser = setRaygunUser;
//# sourceMappingURL=setRaygunUser.js.map